import { Link } from "react-router-dom";
import { getCategory } from "@/mocks/categories";
import type { NewsItem } from "@/mocks/items";

const hotLabelTone: Record<string, string> = {
  '爆': 'bg-primary-500 text-background-50',
  '热': 'bg-accent-500 text-background-50',
  '新': 'bg-secondary-500 text-background-50',
  '专': 'bg-foreground-900 text-background-50',
};

export default function NewsCard({ item, horizontal = false }: { item: NewsItem; horizontal?: boolean }) {
  const cat = getCategory(item.cat);
  return (
    <article
      className={`group flex w-full overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all hover:border-background-300 hover:bg-background-50 ${
        horizontal ? "flex-col sm:flex-row" : "flex-col"
      }`}
    >
      <div className={`relative overflow-hidden ${horizontal ? "w-full shrink-0 sm:w-44 md:w-56" : "w-full"}`}>
        <Link to={`/item/${item.id}`} className={`relative block overflow-hidden ${horizontal ? "min-h-[150px] sm:h-full sm:min-h-[130px]" : "aspect-[16/9]"}`}>
          <img
            src={item.cover}
            alt={item.title}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </Link>
        {item.hotLabel && (
          <span className={`absolute top-2 left-2 inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-bold ${hotLabelTone[item.hotLabel]}`}>
            {item.hotLabel}
          </span>
        )}
      </div>
      <div className={`flex flex-1 flex-col ${horizontal ? "p-3 md:p-4" : "p-4"}`}>
        <div className="mb-2 flex flex-wrap items-center gap-2">
          {cat && (
            <Link
              to={`/category/${cat.slug}`}
              className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-800"
            >
              <i className="ri-price-tag-3-line"></i>
              {cat.name}
            </Link>
          )}
          {item.isNew && (
            <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
              <i className="ri-sparkling-line"></i>NEW
            </span>
          )}
        </div>
        <h3 className="font-heading text-base leading-snug font-bold text-foreground-950 line-clamp-2 md:text-lg">
          <Link to={`/item/${item.id}`} className="cursor-pointer transition-colors group-hover:text-primary-700">
            {item.title}
          </Link>
        </h3>
        <p className={`mt-2 text-sm leading-6 text-foreground-600 line-clamp-2 ${horizontal ? "hidden md:block" : ""}`}>
          {item.summary}
        </p>
        <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>{item.reads}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-chat-1-line"></i>{item.comments}
          </span>
          <span className="ml-auto inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>{item.time}
          </span>
        </div>
      </div>
    </article>
  );
}